// src/components/Home.js
import React, { useState, useEffect } from 'react';
import './Home.css';
import image1 from '../images/IMG_4330.JPG';
import image2 from '../images/IMG_4334.JPG';
import image3 from '../images/IMG_4342.JPG';
import image4 from '../images/IMG_4370.JPG';
import image5 from '../images/image2.png';
import Stats from './Stats';

const Home = () => {
  const images = [image5, image2, image3, image4, image1];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setNextImageIndex((currentImageIndex + 1) % images.length);
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
        setIsTransitioning(false);
      }, 1000);
    }, 4000);

    return () => clearInterval(interval);
  }, [currentImageIndex, images.length]);

  return (
    <div id="home" className="home-container">
      <div
        className={`background-image ${isTransitioning ? 'fade-out' : 'visible'}`}
        style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
      ></div>
      <div
        className={`background-image ${isTransitioning ? 'fade-in' : 'hidden'}`}
        style={{ backgroundImage: `url(${images[nextImageIndex]})` }}
      ></div>
      <div className="overlay">
        <Stats />
      </div>
    </div>
  );
};

export default Home;
